module.exports = "pegasus/assets/blocks/image-3-theme5.png";